<template>
  <div class="bg-white rounded box-shadow p-3">
    <b-modal
      id="trainee-grade-modal"
      size="lg"
      title="Marks Information"
      hide-footer
    >
      <div v-show="show"
           class="alert alert-danger alert-dismissible fade show" role="alert">
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br/>
        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <div class="form-row">
          <div class="col-md-6">
            <label for="exam_id">Exam <span class="c-required">*</span></label>
            <select v-model="trainee_grade.exam_id" v-validate="'required'" id="exam_id" name="exam_id" class="form-control form-control-sm">
              <option :value="''">Select Exam</option>
              <option v-for="(exam, index) in exams" :key="index" :value="exam.id">{{ exam.title }}</option>
            </select>
            <div class="invalid-feedback">Please Select Exam</div>
          </div>
          <div class="col-md-6">
            <label for="marks" class="col-form-label col-form-label-sm">Marks <span style="color: red">*</span></label>
            <input type="number" v-model="trainee_grade.marks" v-validate="{ required: true}" maxlength="3" id="marks" name="marks" class="form-control form-control-sm"  placeholder="Marks"/>
            <div class="invalid-feedback">Please enter marks and length must be 3 digit highest</div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-6">
            <label for="grade" class="col-form-label col-form-label-sm">Grade <span style="color: red">*</span></label>
            <input type="text" v-model="trainee_grade.grade" v-validate="{ required: true}" id="grade" name="grade" class="form-control form-control-sm"  placeholder="Grade"/>
            <div class="invalid-feedback">Please enter grade</div>
          </div>
          <div class="col-md-6">
            <label for="remarks" class="col-form-label col-form-label-sm">Remarks</label>
            <input type="text" v-model="trainee_grade.remarks" id="remarks" name="remarks"  class="form-control form-control-sm"  placeholder="Remarks"/>
          </div>
        </div>
        <div class="form-row mt-3 mb-3">
          <div class="float-right">
            <b-button variant="success" size="sm" v-if="!this.btn_edit" class="form-control-sm mr-2" @click.prevent="save" >Add Grade</b-button>
            <b-button variant="warning" size="sm" v-if="this.btn_edit"  class="form-control-sm mr-2" @click.prevent="update">Update</b-button>
            <b-button variant="danger" size="sm" class="form-control-sm" @click="$bvModal.hide('trainee-grade-modal')">Cancel</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  name: "TraineeGrade",
  props: ["trainee_grade", "btn_edit"],
  components: { Datepicker },
  data() {
    return {
      exams: {},
      validation_errors: {},
      show: false,
    };
  },
  mounted() {
    this.getTraineeBatch();
  },

  methods: {
    customExamDate(date) {
      this.trainee_grade.exam_date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
    getTraineeBatch(){
      const trainee_id = this.$route.params.trainee_id;
      http.get("api/trainee/exams/" + trainee_id).then(response => {
        this.exams = response.data.exams;
        console.log(response)
      });
    },
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.trainee_grade.trainee_id = this.$route.params.trainee_id;
          http
            .post("api/trainee/grades", this.trainee_grade)
            .then(response => {
              if (!response.data.error) {
                if (response.data.permissionError) {
                  this.$bvToast.toast(response.data.permissionError, {
                    title: "Error",
                    autoHideDelay: 5000,
                    variant: "danger"
                  });
                } else {
                  this.$bvModal.hide("trainee-grade-modal");
                  this.$emit("resetForm");
                  this.$emit("getTraineeGrade", this.trainee_grade.trainee_id);
                  this.$bvToast.toast(response.data.message, {
                    title: "Success",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                }
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
            });
        }
      });
    },
    update() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.trainee_grade.trainee_id = this.$route.params.trainee_id;
          http
            .put("api/trainee/grades/" + this.trainee_grade.id, this.trainee_grade)
            .then(response => {
              if (!response.data.error) {
                if (response.data.permissionError) {
                  this.$bvToast.toast(response.data.permissionError, {
                    title: "Error",
                    autoHideDelay: 5000,
                    variant: "danger"
                  });
                } else {
                  this.$bvModal.hide("trainee-grade-modal");
                  this.$emit("resetForm");
                  this.$emit("getTraineeGrade", this.trainee_grade.trainee_id);
                  this.$bvToast.toast(response.data.message, {
                    title: "Success",
                    autoHideDelay: 5000,
                    variant: "success"
                  });
                }
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
            });
        }
      });
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    }
  },
};
</script>
<style lang="scss">
  .vdp-datepicker input {
    width: 100%;
    border-radius: 3px;
    border: 1px solid #ced4da;
    height: 30px;
    padding-left: 15px;
    color: #6b757d;
  }
</style>
